.header {
  display: flex;
  min-width: 0;
  min-height: 3.75rem;
  align-items: center;
  gap: var(--space-4);
}

.back {
  border: 0;
  cursor: pointer;
  display: grid;
  width: 3rem;
  height: 3rem;
  flex: none;
  border-radius: var(--radius-md);
  color: var(--color-play-action-text);
  background: var(--gradient-accent);
  text-decoration: none;
  place-items: center;
  box-shadow:
    inset 0 0.125rem 0 var(--color-play-secondary-action-highlight),
    0 0.25rem 0 var(--color-play-action-edge),
    0 0.625rem 1.25rem var(--color-play-action-shadow);
  transition:
    transform var(--duration-fast) var(--ease-standard),
    box-shadow var(--duration-fast) var(--ease-standard);
}

.header[data-centered] {
  display: grid;
  width: 100%;
  grid-template-columns: minmax(0, 1fr) auto;
}

.rightSection {
  justify-self: end;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.back:focus-visible {
  outline: 0.125rem solid var(--color-focus);
  outline-offset: 0.1875rem;
}

.back:active {
  transform: translateY(0.125rem);
  box-shadow:
    inset 0 0.125rem 0 var(--color-play-secondary-action-highlight),
    0 0.125rem 0 var(--color-play-action-edge),
    0 0.25rem 0.5rem var(--color-play-action-shadow);
}

.title {
  min-width: 0;
  margin: 0;
  font-family: var(--font-family-display);
  font-size: clamp(1.5rem, 4vw, 2.25rem);
  line-height: 1.1;
  font-weight: 800;
}

.heading {
  display: grid;
  min-width: 0;
  gap: var(--space-1);
}

.eyebrow {
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  line-height: 1.2;
  text-transform: uppercase;
}

@media (hover: hover) and (pointer: fine) {
  .back:hover {
    filter: brightness(1.04);
  }
}

.back[data-compact] {
  width: var(--header-control-height, 2.625rem);
  height: var(--header-control-height, 2.625rem);
}
